<ef-indirect-rate-cost-center
    [items]="costCenters$ | async"
    [rates]="rateStructures$ | async"
    [showAdd]="showAdd$ | async"
    [selectedError]="selectedError"
    (ShowError)="ShowError.next($event)"
    (SaveItem)="onSaveItem($event)"
></ef-indirect-rate-cost-center>
